 import useServiceHook from "@hooks/useServiceHook";
import FeatureFlagService from "@services/featureFlags/FeatureFlagService";

type FeatureFlagResult = [boolean, boolean, boolean];
// [loading, error, flagValue]

/**
 * Hook to fetch the value of a feature flag from the backend API.
 *
 * @param flagName - The flag identifier matching the backend dataclass field name.
 * @returns [loading, error, flagValue] — flagValue defaults to false while loading or on error.
 */
export function useFeatureFlag(flagName: string): FeatureFlagResult {
    const [loading, error, _errMsg, value] = useServiceHook<boolean>(
        FeatureFlagService.getFeatureFlag,
        [flagName],
    );

    const isLoading = loading === true || loading === null;
    const isError = error === true;
    const flagValue = (!isLoading && !isError && value === true);

    return [isLoading, isError, flagValue];
}

// ─── Convenience hooks for known feature flags ───────────────────────────────
// Add a new export here when a new flag is introduced on the backend.

/** Whether FlexiOwn 2.1 quoting flow is enabled. */
export function useFoQuoting21Flag(): FeatureFlagResult {
    return useFeatureFlag("fo_quoting_2_1_enabled");
}

/** Whether the AU FO 2.0 FE onboarding journey is enabled. */
export function useAuFoV2FeJourneyFlag(): FeatureFlagResult {
    return useFeatureFlag("au_fo_v2_fe_journey_enabled");
}

